import React from 'react'
import { connect } from 'react-redux'

import { Form } from 'react-bootstrap'

import {
  handleHospitalizationOutcomeChartFieldChange,
  togglePatientDiedorDischarged,
  submitChartHospitalizationOutcome,
 } from '../reducers/hospitalizationOutcomeFormReducer'
 import {
   handleChartFieldChange,
 } from '../reducers/chartFormReducer'

import FormInput from '../../../components/FormInput'
import SelectWithOptionalTextField from '../../../components/SelectWithOptionalTextField'


const HospitalizationOutcomeForm = (props) => {

  const handleChange = (e) => {
    const { name, value } = e.target
    return props.handleHospitalizationOutcomeChartFieldChange(name, value)
  }

  const handlePlaceOfResidenceChange = (e) => {
    const { name, value } = e.target
    props.handleHospitalizationOutcomeChartFieldChange(name, value)

    if (name === 'place_of_residence' && value?.toLowerCase() !== 'other') {
      props.handleHospitalizationOutcomeChartFieldChange('place_of_residence_other_text', '')
    }
  }

  const handleDateChange = (key, date) => {
    props.handleHospitalizationOutcomeChartFieldChange(key, date)
    props.handleChartFieldChange('chartDateErrorMessage', '')

    if ((date instanceof Date && !isNaN(date)) || date === null) {
      const hospitalizationOutcome = {...props, [key]: date, 'chartDateErrorMessage': key}
      return props.submitChartHospitalizationOutcome(hospitalizationOutcome)
    }
  }

  const getHelperText = (key) => {
    if (!props[`${key}`]) {
      if (chartDateErrorMessage && chartDateErrorMessage !== '' && chartDateErrorMessage.includes('[')) {
        let splitError = chartDateErrorMessage.split('[')[1].split(']')[0]
        let arr = splitError.split('_')
        let joined = arr.map(key => key.charAt(0).toUpperCase() + key.slice(1)).join('')
        let camelCase = joined.charAt(0).toLowerCase() + joined.slice(1).split(']')[0]
        if (key === camelCase || camelCase.includes(`${key}`)) {
          return chartDateErrorMessage.split('[')[0]
        } else {
          return 'Date is Invalid'
        }
      } else {
        return 'Date is Invalid'
      }
    } else {
      return 'Date is Valid'
    }
  }

  const getHospitalOutcomeRequired = (patientDied, patientDischarged) => {
    let required = true
    if (props.patientDied || props.patientDischarged) {
      required = false
    }
    return required
  }

  const handleBlur = () => {
    props.submitChartHospitalizationOutcome(props)
  }

  const handleTogglePatientDiedorDischarged = (e) => {
    if (!e || !e.target || !e.target.name ) {
      return
    }

    const name = e.target.name

    if (name === 'patientDischarged' && props.patientDischarged === true) {
      return props.togglePatientDiedorDischarged(true, false)
    }

    if (name === 'patientDischarged' && props.patientDischarged === false) {
      return props.togglePatientDiedorDischarged(false, true)
    }

    if (name === 'patientDied' && props.patientDied === true) {
      return props.togglePatientDiedorDischarged(false, true)
    }

    if (name === 'patientDied' && props.patientDied === false) {
      return props.togglePatientDiedorDischarged(true, false)
    }
  }

  const placeOfResidenceOptions = [
    {value: 'Private Residence (home)'},
    {value: 'Healthcare facility such as Nursing home/skilled nursing facilities Rehabilitation facility, Long termacute care hospital (LTACH)'},
    {value: 'Assisted living, Residential care/Group home'},
    {value: 'Hospice (place to receive near the end of life care for patients with terminal diseases)'},
    {value: 'Other Institutions such as: Military facility, Jail/Prison, etc.'},
    {
      value: 'Other',
      textFields: [{
        displayName: 'Please Specify',
        fieldName: 'place_of_residence_other_text'
      }]
    },
  ]

  const {
    patientDied,
    patientDischarged,
    dateOfDeath,
    causesOfDeath,

    dateOfDischarge,
    // dischargedHome,
    // dischargedHomeSpecification,
    dischargedWithAntibiotics,
    chartDateErrorMessage,

    chartForReview,
  } = props


  return (
    <div id="HospitalizationOutcomeForm">

      <Form
        validated={props.chartIsIncompleteModalData.length !== 0 ? true: false}
      >
        <Form.Label>
          Was the patient discharged from the hospital or did the patient die?
        </Form.Label>
        <Form.Check
          id='patientDied'
          name='patientDied'
          label='Patient Died'
          type='radio'
          checked={patientDied === true}
          onChange={handleTogglePatientDiedorDischarged}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={getHospitalOutcomeRequired()}
        />

        <Form.Check
          id='patientDischarged'
          name='patientDischarged'
          label='Patient Discharged'
          type='radio'
          checked={patientDischarged === true}
          onChange={handleTogglePatientDiedorDischarged}
          onBlur={handleBlur}
          disabled={chartForReview}
          required={getHospitalOutcomeRequired()}
        />
      </Form>

      <br/>

      {patientDied === true ?
        <Form>

          <FormInput
             label="Date of death"
             type='date'
             value={dateOfDeath}
             onChange={(date) => handleDateChange('dateOfDeath', date)}
             onBlur={handleBlur}
             disabled={chartForReview}
             required={true}
             errorText={getHelperText('dateOfDeath')}
           />

          <FormInput
            label={'Cause(s) of death (as reported in the chart)'}
            name={'causesOfDeath'}
            placeholder={'Please enter the cause(s) of death'}
            value={causesOfDeath}
            type={'textarea'}
            xs={12}
            sm={12}
            md={8}
            lg={6}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={chartForReview}
            required={true}
          />

        </Form>
        :
        null
      }

      {patientDischarged === true ?
        <Form>

          <FormInput
            label="Date that the patient was discharged from the hospital"
            type='date'
            value={dateOfDischarge}
            onChange={(date) => handleDateChange('dateOfDischarge', date)}
            onBlur={handleBlur}
            disabled={chartForReview}
            required={true}
            errorText={getHelperText('dateOfDischarge')}
          />

          <SelectWithOptionalTextField
            label='Patient was discharged to:'
            options={placeOfResidenceOptions}
            handleChange={handlePlaceOfResidenceChange}
            selectFieldName={'place_of_residence'}
            selected={props.place_of_residence}
            onBlur={handleBlur}
            disabled={chartForReview}
            placeholder="Please make a selection"
            required={true}
            {...props}
          />

          <Form.Label>
            Discharge with any oral or IV antibiotics for GNBI?
          </Form.Label>

          <Form.Check
            id="dischargedWithoutAntibiotics"
            name="dischargedWithoutAntibiotics"
            label='No'
            type='radio'
            checked={dischargedWithAntibiotics === false}
            onChange={(e) => props.handleHospitalizationOutcomeChartFieldChange('dischargedWithAntibiotics', !dischargedWithAntibiotics)}
            onBlur={handleBlur}
            disabled={chartForReview}
            required={true}
          />

          <Form.Check
            id="dischargedWithAntibiotics"
            name="dischargedWithAntibiotics"
            label='Yes'
            type='radio'
            checked={dischargedWithAntibiotics === true}
            onChange={(e) => props.handleHospitalizationOutcomeChartFieldChange('dischargedWithAntibiotics', !dischargedWithAntibiotics)}
            onBlur={handleBlur}
            disabled={chartForReview}
            required={true}
          />

        </Form>
        :
        null
      }

    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    patientChartUrl: state.chartFormReducer.patientChartUrl,
    chartIsIncompleteModalData: state.chartFormReducer.chartIsIncompleteModalData,
    chartDateErrorMessage: state.chartFormReducer.chartDateErrorMessage,
    patientDied:  state.hospitalizationOutcomeFormReducer.patientDied,
    patientDischarged:  state.hospitalizationOutcomeFormReducer.patientDischarged,
    dateOfDeath: state.hospitalizationOutcomeFormReducer.dateOfDeath,
    causesOfDeath: state.hospitalizationOutcomeFormReducer.causesOfDeath,

    dateOfDischarge: state.hospitalizationOutcomeFormReducer.dateOfDischarge,
    // dischargedHome: state.hospitalizationOutcomeFormReducer.dischargedHome,
    // dischargedHomeSpecification: state.hospitalizationOutcomeFormReducer.dischargedHomeSpecification,
    place_of_residence: state.hospitalizationOutcomeFormReducer.place_of_residence,
    place_of_residence_other_text: state.hospitalizationOutcomeFormReducer.place_of_residence_other_text,
    dischargedWithAntibiotics: state.hospitalizationOutcomeFormReducer.dischargedWithAntibiotics,
    hospitalizationOutcomeUrl: state.hospitalizationOutcomeFormReducer.hospitalizationOutcomeUrl,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleHospitalizationOutcomeChartFieldChange: (key, value) => {
      return dispatch(handleHospitalizationOutcomeChartFieldChange(key, value))
    },

    togglePatientDiedorDischarged: (patientDied, patientDischarged) => {
      return dispatch(togglePatientDiedorDischarged(patientDied, patientDischarged))
    },

    submitChartHospitalizationOutcome: (props) => {
      return dispatch(submitChartHospitalizationOutcome(props))
    },

    handleChartFieldChange: (key, value) => {
      return dispatch(handleChartFieldChange(key, value))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalizationOutcomeForm)
